import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import {
  ACTION_TO_ACTION,
  LIVE_CHAT,
} from '../../containers/OrderHelpTemplateContainer/templateTypes';

import ModalFooter from '../ModalFooter';
import OrderHelpActionRows from '../OrderHelpActionRows';

import i18n from '../../utils/i18n';

/**
 * A generic dynamic actions template to render a list of clickable actions.
 */
export function OrderHelpTemplateActionToAction({
  iframe,
  data: { actions },
  interactionId,
  actionId,
  subType,
  hideFooterPrevious,
  requestInteraction,
}) {
  const onActionClick = (clickedActionId, clickedActionTemplate) => {
    requestInteraction({
      parentActionId: actionId,
      parentActionTemplate: ACTION_TO_ACTION,
      selectedActionId: clickedActionId,
      selectedActionTemplate: clickedActionTemplate,
      templateData: {
        selected_action_id: clickedActionId,
        selected_action_template: clickedActionTemplate,
      },
    });
  };

  const isShowingLiveChat = subType === LIVE_CHAT;

  return (
    <Fragment>
      <OrderHelpActionRows iframe={iframe} actions={actions} onActionClick={onActionClick} />

      {interactionId && (
        <ModalFooter
          onSubmit={
            isShowingLiveChat
              ? () => {
                  requestInteraction({
                    parentActionId: actionId,
                    parentActionTemplate: LIVE_CHAT,
                    templateData: {},
                  });
                }
              : null
          }
          modal={iframe}
          cta={i18n.gettext('Done')}
          hidePrevious={hideFooterPrevious}
        />
      )}
    </Fragment>
  );
}

OrderHelpTemplateActionToAction.propTypes = {
  /**
   * Template data to fill out the generic template.
   */
  data: PropTypes.shape({
    actions: PropTypes.array,
  }),
  /**
   * The ID for the current interaction if there is one.
   */
  interactionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  /**
   * The sub template to show over the main template.
   * This will also show a done button and remove the previous button if the type is `live_chat`.
   */
  subType: PropTypes.string,
  /**
   * Which help screen the template is currently on.
   */
  actionId: PropTypes.string.isRequired,
  /**
   * Whether to style the template appropriately for a modal.
   */
  iframe: PropTypes.bool.isRequired,
  /**
   * Whether to hide the previous button for the footer
   */
  hideFooterPrevious: PropTypes.bool,
  /**
   * The dispatch action that will be triggered onClick for each OrderHelpActionRows.
   * This will be used to update the dynamic action and grab the next self help page
   */
  requestInteraction: PropTypes.func.isRequired,
};

OrderHelpTemplateActionToAction.defaultProps = {
  data: {},
  interactionId: null,
  subType: null,
  hideFooterPrevious: true,
};

export default OrderHelpTemplateActionToAction;
